import { render } from "./Pagination.vue?vue&type=template&id=7357bbba&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=7357bbba&lang=scss&scoped=true"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7357bbba"]])

export default __exports__